import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { ActionReducerMap, StoreModule } from "@ngrx/store";

import { SBPopularCategoriesEffect } from "./sb-popular-categories/sb-popular-categories.effect";
import { sbPopularCategoriesReducer } from "./sb-popular-categories/sb-popular-categories.reducer";
import { HomeFeatureState } from "./state";

export const HOME_FEATURE_REDUCER: ActionReducerMap<HomeFeatureState["homeFeature"]> = {
	sbPopularCategory: sbPopularCategoriesReducer,
};

const HOME_EFFECTS = [SBPopularCategoriesEffect];
@NgModule({
	imports: [EffectsModule.forFeature(HOME_EFFECTS), StoreModule.forFeature("homeFeature", HOME_FEATURE_REDUCER)],
})
export class CommonHomeSdkModule {}
